document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("mera-popup");
  if (!popup) return;

  const KLAVIYO_LIST_ID = "U3bwrq";

  const closeBtn = popup.querySelector(".mera-popup__close");
  const overlay = popup.querySelector(".mera-popup__overlay");
  const nextBtn = popup.querySelector(".mera-popup__next");
  const submitBtn = popup.querySelector(".mera-popup__submit");

  const step1 = popup.querySelector('[data-step="1"]');
  const step2 = popup.querySelector('[data-step="2"]');
  const success = popup.querySelector(".mera-popup__success");

  const emailInput = document.getElementById("mera-popup-email");
  const phoneInput = document.getElementById("mera-popup-phone");

  const copyBtn = popup.querySelector(".mera-popup__copy");

  if (!sessionStorage.getItem("mera-popup-shown")) {
    setTimeout(() => {
      popup.classList.add("active");
      sessionStorage.setItem("mera-popup-shown", "1");
    }, 4000);
  }

  function closePopup() {
    popup.classList.remove("active");
  }

  function getSelectedConcerns() {
    const checked = popup.querySelectorAll('[data-step="1"] input[type="checkbox"]:checked');
    return Array.from(checked).map(input => input.value);
  }

  function sendToKlaviyo(email, phone = "") {
    const selectedConcerns = getSelectedConcerns();

    const formData = new URLSearchParams();
    formData.append("g", KLAVIYO_LIST_ID);
    formData.append("email", email);
    formData.append("$fields", "phone_number,problematique_peau,source");
    formData.append("phone_number", phone);
    formData.append("problematique_peau", selectedConcerns.join(", "));
    formData.append("source", "Popup Shopify Mera Beauty");

    return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: formData.toString()
    });
  }

  closeBtn.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);

  nextBtn.addEventListener("click", async () => {
    const email = emailInput.value.trim();

    if (!email || !email.includes("@")) {
      emailInput.focus();
      emailInput.style.borderColor = "#d11";
      return;
    }

    emailInput.style.borderColor = "";

    step1.classList.remove("mera-popup__step--active");
    step2.classList.add("mera-popup__step--active");
  });

  submitBtn.addEventListener("click", async () => {
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();

    if (!phone || phone.length < 8) {
      phoneInput.focus();
      phoneInput.style.borderColor = "#d11";
      return;
    }

    phoneInput.style.borderColor = "";
    submitBtn.disabled = true;
    submitBtn.textContent = "VALIDATION...";

    try {
      await sendToKlaviyo(email, phone);
    } catch (e) {
      console.error("Erreur Klaviyo :", e);
    }

    submitBtn.disabled = false;
    submitBtn.textContent = "JE RÉCUPÈRE MES -10 %";

    step2.classList.remove("mera-popup__step--active");
    success.style.display = "block";
  });

  if (copyBtn) {
    copyBtn.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText("MERA10");

        const svg = copyBtn.innerHTML;
        copyBtn.innerHTML = "✓";
        copyBtn.classList.add("copied");

        setTimeout(() => {
          copyBtn.innerHTML = svg;
          copyBtn.classList.remove("copied");
        }, 1800);

      } catch (e) {
        console.error(e);
      }
    });
  }

});